import React from 'react';
import { Button, onlinebankportal, githubUrl, rmanage, taskify, taskifyUrl, trafficer } from './Imports';

function Projects() {
    return (
        <div className="projects">
            <header className="sectionName">
                <div className='line' />
                <h3><i>Some of my Recent Work</i></h3>
                <div className='line' />
            </header>

            <div className="projectsContainer">
                <div className="project">
                <div className="pName">
                        <h2>Taskify</h2>
                        <h5><i>( Live )</i></h5>
                    </div>
                    <img src={taskify} alt="Taskify - Streamline your DSM tasks and boost productivity" className='projectImage' />
                    <p>
                        • Developed TASKIFY, a task management app for DSM tasks using Java, Spring Boot, MongoDB, and ReactJS, featuring secure JWT authentication, dynamic state management with Redux, and responsive design with SCSS.<br/>
                        <br/>
                        • Implemented Docker containerization for efficient deployment, enhancing productivity with DSM-specific features like task filtering, team overviews, activity logs, and customizable themes. <br/>
                    </p>
                    
                    {/* <Button className='button' variant="contained" href={githubUrl} target="_blank">
                        Source Code
                    </Button> */}
                    <div className="links">
                        <Button className='button' variant="contained" href={githubUrl} target="_blank">
                            Source Code
                        </Button>
                        <Button className='button' variant="contained" href={taskifyUrl} target="_blank">
                            Visit Live
                        </Button>
                    </div>
                </div>

                <div className="project">
                    <div className="pName">
                        <h2>Trafficer</h2>
                        <h5><i>( Patented )</i></h5>
                    </div>
                    {/* <img src={trafficer} alt="Trafficer" className='projectImage' /> */}
                    <p>
                        • Developed Trafficer, an innovative application to evacuate emergency vehicles from traffic jams using IoT devices. Created with MIT App Inventor, the app controls traffic lights wirelessly, utilizing Bluetooth sensors and an Arduino Genuino 101 for efficient operation.<br/>
                        <br/>
                        • The idea behind Trafficer is officially patented and secured a position in the Intel Future Skill Forum, a national showcase for tech creators by Intel in collaboration with NITI Aayog's Atal Innovation Mission (AIM), highlighting the project's impact and innovation in real-time traffic management.<br/>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Projects;
